import React from 'react';
import { Link } from 'react-router-dom';

const Evaporators = () => {
  return (
    <div>
      {/* Breadcrumb */}
      <div className="bg-gray-100 py-4">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-600">
            <Link to="/" className="hover:text-accent">Home</Link> / 
            <Link to="/services" className="hover:text-accent"> Services</Link> / 
            <span className="text-gray-900"> Evaporators</span>
          </div>
        </div>
      </div>

      {/* Header */}
      <section className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">Evaporators</h1>
          <p className="text-xl text-gray-300">Advanced Evaporation Solutions for Process Industries</p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <p className="text-lg text-gray-700">
            Under this category, we offer our customers a wide range of Falling Film Evaporators, Rising Film Evaporators, Forced Recirculation Evaporator, Wiped Film Evaporator, Scrapped Surface Evaporator, Batch Type Evaporator and Mechanical Vapor Recompression MVR. Our products are manufactured under the strict guidance and vigilance of vendors' trained professionals in adherence with the international standards. These are widely used for reducing volume by evaporating water.
          </p>
        </div>
      </section>

      {/* Falling Film Evaporators */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Falling Film Evaporators</h2>
          <p className="text-gray-700 mb-6">
            The falling film evaporator is the type most often used in the dairy & distillery industry. In a falling film evaporator the liquor is introduced at the top of a vertically arranged heating surface and forms a thin film that flows down over the heating surface. The heating surface may consist of stainless steel tubes or plates. The plates are stacked together forming a pack with the product on one side of the plates and steam on the other. When tubes are used, the liquors form a film on the inside of the tube, which is surrounded by steam. The product is first preheated to a temperature equal to or slightly higher than the evaporation temperature.
          </p>

          <h3 className="text-2xl font-bold mb-4 text-accent">Salient Features of ATHENA's Manufactured Falling Film Evaporator:</h3>
          <ul className="space-y-3 feature-list">
            <li className="text-gray-700">Suitable for heat sensitive products</li>
            <li className="text-gray-700">Concentration level can be achieved upto 45% TS</li>
            <li className="text-gray-700">Used for the concentration of Milk, Distillery, juices etc.</li>
            <li className="text-gray-700">Highly Energy Efficient</li>
            <li className="text-gray-700">Plant can run continuously for 20-22 hrs without increase in acidity</li>
            <li className="text-gray-700">Plant designed for lower temperature difference thus no denaturation of protein</li>
            <li className="text-gray-700">Least thermal degradation to milk protein</li>
            <li className="text-gray-700">Plant orifices selected correctly to avoid vapor losses thus better steam economy</li>
            <li className="text-gray-700">Low energy consumption (Steam, Power, cooling water)</li>
            <li className="text-gray-700">Easy operation</li>
            <li className="text-gray-700">No scale formation in tubes</li>
            <li className="text-gray-700">Special design of Vapor Separators</li>
          </ul>
        </div>
      </section>

      {/* Forced Recirculation Evaporator */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Forced Recirculation Evaporator</h2>
          <p className="text-gray-700 mb-6">
            There are many types of forced circulation evaporators in use today. The unit with the single or multi pass heat exchanger on the discharge side of the pump is most feasible where small diameter tubes can be used. One of the most important considerations in the design of forced circulation evaporators is the manner in which the heated liquor is admitted to the vapor liquor separator. Tangential entry at liquor level is most preferred option.
          </p>

          <h3 className="text-2xl font-bold mb-4 text-accent">Salient Features of ATHENA's Manufactured Forced Circulation Type Evaporators:</h3>
          <ul className="space-y-3 feature-list">
            <li className="text-gray-700">Ideally suited for highly viscous liquids or liquids containing suspended solids</li>
            <li className="text-gray-700">The liquid to be evaporated is heated in tubular heater at large circulation volumes to obtain high liquid velocities</li>
            <li className="text-gray-700">Evaporation takes place in a separator as the product is flashed down to its operating pressure</li>
          </ul>

          <h3 className="text-xl font-bold mb-3 mt-6 text-green">Application:</h3>
          <ul className="space-y-2 feature-list">
            <li className="text-gray-700">Distillery effluent /Black liquor</li>
            <li className="text-gray-700">Tomato /Mango Pulp paste</li>
            <li className="text-gray-700">Malt mix slurry</li>
            <li className="text-gray-700">Sugar Syrup/Glucose</li>
          </ul>
        </div>
      </section>

      {/* Scrapped Surface Evaporator */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Scrapped Surface Evaporator</h2>
          
          <h3 className="text-2xl font-bold mb-4 text-accent">Salient Features of ATHENA's Manufactured Scrapped Surface Evaporator:</h3>
          <ul className="space-y-3 feature-list">
            <li className="text-gray-700">Useful for Concentration of very viscous material</li>
            <li className="text-gray-700">The concentration level can be achieved up to 65-83% TS</li>
            <li className="text-gray-700">The scrapper attached with gear motor is an important part of this evaporator</li>
            <li className="text-gray-700">Mainly used for the Effluent, Horlicks mix, malt etc.</li>
            <li className="text-gray-700">Optimizing thermal efficiency</li>
            <li className="text-gray-700">Saving Floor space</li>
            <li className="text-gray-700">High Concentrations of Solids</li>
            <li className="text-gray-700">Complies with strict international standard of hygiene</li>
            <li className="text-gray-700">CIP is required only after 30-40 days of continuous running</li>
            <li className="text-gray-700">Suitable to concentrate the product upto 70% solids or higher</li>
          </ul>
        </div>
      </section>

      {/* Wiped Film Evaporator */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Wiped Film Evaporator</h2>
          
          <h3 className="text-2xl font-bold mb-4 text-accent">Salient Features of ATHENA's Manufactured Wiped Film Evaporator:</h3>
          <ul className="space-y-3 feature-list">
            <li className="text-gray-700">The concentration level can be achieved up to 75-80% TS</li>
            <li className="text-gray-700">Used in Herbal extraction & Solvent Recovery</li>
            <li className="text-gray-700">Higher heat flux due to more uniform film</li>
            <li className="text-gray-700">No Fouling or dry spots</li>
            <li className="text-gray-700">High turbulence</li>
            <li className="text-gray-700">Rapid surface renewal</li>
            <li className="text-gray-700">Refining of waste lube oil purification</li>
            <li className="text-gray-700">Solvent Recovery</li>
          </ul>
        </div>
      </section>

      {/* Agitated Thin Film Evaporator */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Agitated Thin Film Evaporator</h2>
          <p className="text-gray-700 mb-6">
            Conventional heat transfer equipment may not be well suited for certain evaporation applications, particularly those involving heat sensitive products, liquids with suspended solids, viscous materials, or chemical constituents that exhibit fouling or foaming tendencies. For products like these, mechanically agitated thin-film evaporators are often selected over more conventional evaporators because of their better process economics and performance.
          </p>

          <h3 className="text-2xl font-bold mb-4 text-accent">Salient Features of ATHENA's Manufactured Agitated Thin Film Evaporators:</h3>
          <ul className="space-y-3 feature-list">
            <li className="text-gray-700">Ideal for processing heat sensitive products</li>
            <li className="text-gray-700">Short residence time</li>
            <li className="text-gray-700">Low product "Hold up"</li>
            <li className="text-gray-700">Heated surface fully self-cleaning</li>
            <li className="text-gray-700">Heating & Cooling available in single system</li>
            <li className="text-gray-700">Minimal degradation of heat sensitive products</li>
            <li className="text-gray-700">Suitable for high viscosity product</li>
            <li className="text-gray-700">High surface to volume ratio</li>
          </ul>

          <h3 className="text-xl font-bold mb-3 mt-6 text-green">Application:</h3>
          <ul className="space-y-2 feature-list">
            <li className="text-gray-700">Vacuum Distillation</li>
            <li className="text-gray-700">Drying</li>
            <li className="text-gray-700">Solvent Recovery</li>
            <li className="text-gray-700">For Concentration of bulk drugs, enzymes, juice, milk products etc.</li>
          </ul>
        </div>
      </section>

      {/* Batch Type Evaporator */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Batch Type Evaporators</h2>
          <p className="text-gray-700 mb-6">
            Batch type evaporators include Short tube Calandria and Batch evaporators suitable for small-scale operations and specialized applications where continuous processing is not required.
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Need Custom Evaporator Solutions?</h2>
          <p className="text-lg mb-6 text-gray-300">
            Our engineering team can design the perfect evaporator for your specific requirements
          </p>
          <Link to="/contact" className="btn-primary px-8 py-3 rounded-lg font-semibold inline-block">
            Request a Quote
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Evaporators;